export enum TipoMensagemIndicadorAlerta {
    JUSTIFICATIVA = 1,
    COBRANCA =2,
}